module.exports = __webpack_public_path__ + "img/aquassist-icon.c3a8916f.svg";